module.exports = __webpack_public_path__ + "static/img/边1.60ed8c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边1.png
// module id = 9gLB
// module chunks = 2